import {SystemTertiaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import {kSystemImages} from "../../../constants/images";
import {kSystemIcons} from "../../../constants/icons";
import {useState} from "react";
import {CircularProgress} from "@mui/material";

export default function BrevetExamItem({exam}) {
    // Used in BrevetExamsList to display one single
    // exam item

    // PROPERTIES
    const [isDownloading, setIsDownloading] = useState(false);
    const onDownload = () => {
        setIsDownloading(true);
        setTimeout(() => setIsDownloading(false), 1200);
    };

    // BUILD
    return (
        <div className="w-[260px] h-[120px] bg-backgroundLight4 rounded-[12px] overflow-hidden border-[1px] border-transparent flex flex-col px-[12px] pb-[12px]">
            <div className="flex-1 py-[8px] flex flex-col justify-start">
                <h2 className="text-[16px] font-semibold truncate">
                    {exam?.title}
                </h2>
                <div className={"flex space-x-[6px] justify-start items-center"}>
                    <p className="text-[14px] text-greyLight7 line-clamp-3 mt-[4px]">
                        {exam?.year}
                    </p>
                    <img className="mt-[5px]"
                         src={kSystemImages.dividerStar}
                         style={{height: 12}}
                         alt={""} />
                    <p className="text-[14px] text-greyLight7 line-clamp-3 mt-[4px]">
                        {exam?.origin}
                    </p>
                </div>

            </div>
            <div className={"flex space-x-[8px] justify-start items-center"}>
                <a href={exam.url}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="block">
                    <SystemTertiaryCustomButton
                        label={"Voir"}
                        icon={kSystemIcons.eye}
                        isDisabled={false}
                        isLoading={false}
                        sizeStyle={kButtonStyles.mediumButtonStyle} />
                </a>
                <a href={exam?.url}
                   download={exam?.filename ?? `${exam?.title ?? "Sujet"}.pdf`}
                   onClick={onDownload}
                   className="grow">
                    <SystemTertiaryCustomButton
                        label={"Télécharger"}
                        icon={kSystemIcons.download}
                        isDisabled={!exam?.url}
                        isLoading={isDownloading}
                        loaderComponent={<CircularProgress size={"20px"}
                                                           style={{'color' : 'white'}} />}
                        isFullWidth={true}
                        sizeStyle={kButtonStyles.mediumButtonStyle}
                        extraClass={"grow"} />
                </a>
            </div>
        </div>
    );
}